import { ReactComponent as Loader } from "../icons/preloader.svg";


interface Props {
    size?: 'sm' | 'base' | 'lg' | 'xl' | '2xl';
    tip?: string;
    color?: string;
}
const CustomLoader: React.FC<Props> = ({ size = "base", tip, color = "#403387" }) => {

    const sizes = {
        "sm": "32px",
        "base": "64px",
        "lg": "128px",
        "xl": "248px",
        "2xl": "512px"
    }

    if (!tip) {
        return <div className="justify-content-center"> <Loader style={{margin:'auto'}} width={sizes[size] as string} height={'auto'}></Loader> </div>;
    } else {
        return (<div className="text-center">
            <div className="my-4 justify-content-center" >
                <Loader width={sizes[size] as string} height={'auto'} style={{stroke : {color}}}></Loader>
            </div>
            <p className="text-xl font-medium">{tip}</p>
        </div>);
    }


}


export default CustomLoader;